import React from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { paths } from '@Components/configs';

/*
 * This component handles home page redirection based on user authentication and feature flags.
 * Its purpose is to route users to the appropriate landing page after login
 * or when accessing the root path. If a certain homepage is desired for some users depending
 * on their roles or features, this is where that logic should be implemented.
 */
const HomeRedirect = ({
  isAuthenticated = false,
  isAdminAuthenticated = false,
  flags = {},
}) => {
  // Admin redirects
  if (isAdminAuthenticated) {
    return <Navigate replace to={paths.adminAccount} />;
  }

  // Product user redirects
  if (isAuthenticated) {
    if (flags.liveTrackerEnabled) {
      return <Navigate replace to={paths.productLiveTracker} />;
    }
    if (flags.searchEnabled) {
      return <Navigate replace to={paths.productInfringements} />;
    }
    if (!flags.overviewEnabled && !flags.searchEnabled && flags.reviewEnabled) {
      return <Navigate replace to={paths.productReview} />;
    }
    if (flags.overviewEnabled && !flags.searchEnabled) {
      return <Navigate replace to={paths.productPiracyOverview} />;
    }
    if (flags.contentIdEnabled
      && !flags.searchEnabled
      && !flags.overviewEnabled
      && !flags.reviewEnabled
    ) {
      return <Navigate replace to={paths.productListAssets} />;
    }
    if (flags.cyclopsEnabled && flags.isCyclopsDemo && !flags.cyclopsAnalyticsDisabled) {
      return <Navigate replace to={paths.cyclopsAnalytics} />;
    }
    if (flags.cyclopsEnabled && flags.cyclopsAnalyticsDisabled && flags.isCyclopsDemo) {
      return <Navigate replace to={paths.cyclopsEventsList.replace(':status', 'live')} />;
    }
    if (flags.cyclopsEnabled && !flags.isCyclopsDemo) {
      return <Navigate replace to={paths.cyclopsOrganizations} />;
    }
    if (flags.unconfiguredCompany) {
      return <Navigate replace to={paths.account} />;
    }
    // Add more as needed
  }

  // Not authenticated/default: go to login
  return <Navigate replace to={paths.login} />;
};

HomeRedirect.propTypes = {
  isAuthenticated: PropTypes.bool,
  isAdminAuthenticated: PropTypes.bool,
  flags: PropTypes.object,
};

export default HomeRedirect;
